module.exports = __webpack_public_path__ + "museosans_500_italic-webfont.9b18c65e413c7579bebf.woff2";


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/assets/fonts/museosans_500_italic-webfont.woff2
// module id = ../../../../../src/assets/fonts/museosans_500_italic-webfont.woff2
// module chunks = styles